import React, { memo } from 'react'
import OrangeTimer from '../OrangeTimer/OrangeTimer'
import PropTypes from 'prop-types'
import styles from './ClanSupplyQuestsTimer.scss'
import { useSelector } from 'react-redux'
import Tooltip from 'react-wot-bootstrap/lib/components/Tooltip/Tooltip'
import { ONE_HOUR } from 'constants'
import classNames from 'classnames'
import { CLAN_SUPPLY_QUESTS_TIME_BEFORE_END } from '../../translations'

const tooltipId = 'tooltipId-ClanSupplyQuests'

const ClanSupplyQuestsTimer = memo(({
    cycleEnd,
}) => {
    const { deltaTime } = useSelector(state => state.client)

    return (
        <div
            className={styles.base}
            data-tip
            data-for={tooltipId}
        >
            <div className={styles.effect}>
                <div className={styles.line} />
            </div>
            <OrangeTimer
                endDate={cycleEnd}
                serverDelta={deltaTime}
                className={styles.timer}
                glowAt={2 * ONE_HOUR}
                isSmall
                showDays
            />
            <div className={classNames(styles.effect, styles.effect__rotated)}>
                <div className={styles.line} />
            </div>
            <Tooltip id={tooltipId}>
                <p className={styles['tooltip-message']}>
                    {CLAN_SUPPLY_QUESTS_TIME_BEFORE_END}
                </p>
            </Tooltip>
        </div>
    )
})

ClanSupplyQuestsTimer.propTypes = {
    cycleEnd: PropTypes.number.isRequired,
}

export default ClanSupplyQuestsTimer



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanSupplyQuestsTimer/ClanSupplyQuestsTimer.jsx